import { DEFAULT_CURRENCY_CODE } from '@klear/constants/currency'
import { Money } from '@klear/money'
import type { RouterInputs } from '@klear/ui/lib/trpc'

export type TransferCreateWire = RouterInputs['transfer']['create']

export type TransferForm = {
  sourceOrgId: number | null
  destOrgId: number | null
  money: Money
  notes: string
  internalNotes: string
}

export const EMPTY_TRANSFER_FORM: TransferForm = {
  sourceOrgId: null,
  destOrgId: null,
  money: Money.zero(DEFAULT_CURRENCY_CODE),
  notes: '',
  internalNotes: ''
}

export function isTransferFormDirty(values: TransferForm): boolean {
  return (
    values.sourceOrgId != null ||
    values.destOrgId != null ||
    !values.money.isZero() ||
    values.money.currency !== DEFAULT_CURRENCY_CODE ||
    values.notes.trim().length > 0 ||
    values.internalNotes.trim().length > 0
  )
}

export function optionalTransferText(value: string): string | undefined {
  const trimmed = value.trim()
  return trimmed.length > 0 ? trimmed : undefined
}

export function transferFormToCreateWire(values: TransferForm): TransferCreateWire | null {
  if (values.sourceOrgId == null || values.destOrgId == null) return null

  const input: TransferCreateWire = {
    sourceOrgId: values.sourceOrgId,
    destOrgId: values.destOrgId,
    money: values.money.toJSON()
  }
  const notes = optionalTransferText(values.notes)
  if (notes !== undefined) input.notes = notes
  const internalNotes = optionalTransferText(values.internalNotes)
  if (internalNotes !== undefined) input.internalNotes = internalNotes
  return input
}
